<template>
  <div class="content">
    <div>
      <div class="title" :id="id">{{ list.contentTitle }}</div>
      <div class="desc">
        <div>{{ list.createTime }} 来源：{{ list.releaseName }}</div>
        <div>
          字号:
          <span @click="() => checkFocus(0)" :class="returnFocus(0)">大</span>
          <span @click="() => checkFocus(1)" :class="returnFocus(1)">中</span>
          <span @click="() => checkFocus(2)" :class="returnFocus(2)">小</span>
        </div>
      </div>
      <template class="html-content">
        <!-- class="html-content"  -->
        <div class="html-box design-html" :style="size ? `font-size: ${size};` : ''" v-html="list.contentHtml"></div>
        <div class="file-list" v-for="item in list.contentNewsFileDtoList || list.fileList" :key="item.contentCode"
          @click="donwloand(item)">
          <img src="../../../assets/images/矩形 3.png" alt="文件图标" />
          <span>{{ item.fileName }}</span>
        </div>
      </template>
      <!-- 分享 -->
      <div class="tubiao">
        <div>
          <p>分享：</p>
          <a-popover placement="top">
            <template #content>
              <div class="fork-content">
                <!-- <div id="qrCode" ref="qrCodeDiv"></div> -->
                <img :src="imgSrc" alt="微信分享">
                <div>微信里点击“发现”，扫一下</div>
                <div>二维码便可将本文分享至朋友圈</div>
              </div>
            </template>
            <template #title>
              <span class="fork-title">微信扫一扫：分享</span>
            </template>
            <a class="weixin" @mouseover="aaa"><img src="../../../assets/weixin.png"></a>
          </a-popover>
          <a class="sina" @click="share()"><img src="../../../assets/weibo.png" alt="微博转发"></a>
          <a-button class="print" href="javascript:window.print()">打印</a-button>
        </div>
      </div>
      <div id="qrCode" ref="qrCodeDiv" style="display:none"></div>
    </div>
  </div>
</template>

<script>
import { getInfo } from "@/api/common.js";
import { downloadFile } from "@/api/file";
import getUrlParms from '@/util/urlParamsUtilSync.js'
import QRCode from 'qrcodejs2';
export default {
  name: "content",
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      focus: 1,
      list: {},
      size: "18px",
      index: 1,
      url: "",
      imgSrc: ''
    };
  },
  computed: {
    returnFocus: function () {
      const self = this;
      return function (val) {
        return self.focus === val && "focus";
      };
    },
  },
  created() {
    this.url = location.href
    this._getInfo();
    this.$nextTick(() => {
      this.bindQRCode();
    })

  },
  methods: {
    donwloand(obj) {
      let baseUrl =
        process.env.NODE_ENV === "development"
          ? "http://10.11.0.104:55000"
          : "http://10.10.152.115:55000";
      downloadFile(
        `/api/cloud-fastdfs/fastdfs/download/file/${this.list.tenantCode}/${this.list.appCode}?fileCode=${obj.fileCode}`,
        obj.fileName
      );
    },
    checkFocus(val) {
      const obj = {
        0: "22px",
        1: "18px",
        2: "14px",
      };
      this.focus = val;
      this.size = obj[val];
      if (this.list.contentHtml) {
        this.list.contentHtml = this.list.contentHtml.replace(/FONT-SIZE:/g, "").replace(/font-size:/g, "")        
      }
    },
    _getInfo() {
      const query = this.$route.query.contentCode;
      const type = this.$route.query.type || "contentNews";
      getInfo(query, type).then((res) => {
        this.list = this._.get(res, "data");
      });
    },
    // 动态生成二维码
    bindQRCode: function () {
      new QRCode(this.$refs.qrCodeDiv, {
        text: this.url,
        width: 200,
        height: 200,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
      })
    },
    // 微信二维码展示
    aaa() {
      this.imgSrc = document.getElementById('qrCode').lastElementChild.getAttribute('src')
    },
    share() {
      let message = String(location.href)
      var url = 'https://service.weibo.com/share/share.php?url=' + encodeURIComponent(message)
      window.open(url)
    }
  },
};
</script>

<style scoped lang="less">

.content {
  /* height: 600px; */
  background: white;
  position: relative;
  text-align: center;

  >div {
    display: inline-block;
    width: 1140px;
    background: white;
  }
}

.title {
  text-align: left;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 41px;
  margin-top: 56px;
}

.desc {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eeeeee;

  >div:nth-of-type(1) {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #bcbec0;
    line-height: 80px;
  }

  >div:nth-of-type(2) {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #7f7f7f;
    line-height: 80px;

    >span {
      color: #333333;
      margin-right: 5px;
      padding: 0 3px;
      cursor: pointer;
    }

    >span.focus {
      border: 1px solid #cab484;
      color: #cab484;
    }
  }
}

.html-box {
  text-align: left;
  text-indent: 2em;
  margin-top: 60px;
  margin-bottom: 49px;
  text-align: justify;
  text-justify: inter-ideograph;
}

.html-content {
  width: 1140px;
  margin-top: 60px;
  margin-bottom: 49px;
  text-align: left;
  text-indent: 2em;
}

.html-content:after {
  content: " ";
  display: inline-block;
  width: 100%;
}

.file-list {
  text-align: left;
  margin-bottom: 72px;
  cursor: pointer;

  img {
    width: 24px;
    height: 24px;
    margin-right: 11px;
  }

  span {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    text-decoration: underline;
    color: #bda26d;
    line-height: 40px;
    vertical-align: middle;
  }
}

.ql-align-center img {
  width: 1140px !important;
}

// 分享
.tubiao {
  font-family: "Han Sans CN", "Hiragino Sans GB", "microsoft yahei", Helvetica,
    Arial, sans-serif;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
  background-color: #fff;
  margin-bottom: 40px;
}

.tubiao div {
  display: flex !important;
  line-height: 35px;
}

.tubiao a {
  margin: 0 6px;
}

.tubiao img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.tubiao img:hover {
  cursor: pointer;
}

.tubiao .weixin:hover  img{
  content: url(~@/assets/weixin_hover.png);
}


.tubiao .sina:hover  img{
  content: url(~@/assets/sina_hover.png);
}

/deep/.tubiao .print {
  border: 1px solid #cfbc8e;
  color: #cfbc8e;
  height: 21px;
  line-height: 18px;
  margin-top: 7px;
}

/deep/.tubiao .print:hover{
  background-color: #cfbc8e;
  color: white;
}

/deep/#qrCode {
  margin: 5px 0;
  margin-left: 26%;
}

/deep/#qrCode img {
  text-align: center !important;
  width: 100px !important;
}

.fork-content {
  text-align: center;
}

.fork-content img {
  width: 100px !important;
}

.fork-title {
  font-size: 16px;
  font-weight: 700;
  display: block;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/home/guide/siderContent-01.vue